module.exports = __webpack_public_path__ + "img/kraken_futures-logo.3fe15158.png";